package org.hs_soft.runmynesto.pages.login.component

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.attrsModifier
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.lineHeight
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.silk.components.text.SpanText
import org.hs_soft.runmynesto.domain.config.Dimen
import org.hs_soft.runmynesto.domain.config.FontFamily
import org.hs_soft.runmynesto.domain.config.FontLineHeight
import org.hs_soft.runmynesto.domain.config.FontSizes
import org.hs_soft.runmynesto.domain.config.Theme
import org.hs_soft.runmynesto.domain.util.Res
import org.hs_soft.runmynesto.domain.util.helper.Strings
import org.jetbrains.compose.web.css.backgroundImage
import org.jetbrains.compose.web.css.backgroundPosition
import org.jetbrains.compose.web.css.backgroundRepeat
import org.jetbrains.compose.web.css.height
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.width

@Composable
fun LoginTopLogo()
{
    Column(
        modifier = Modifier
            .fillMaxWidth(),
        horizontalAlignment = Alignment.CenterHorizontally
    )
    {
        Box(
            modifier = Modifier
                .attrsModifier {
                    style {
                        width(Dimen.rmr_icon)
                        height(Dimen.rmr_icon)
                        backgroundPosition("center")
                        backgroundRepeat("no-repeat")
                        backgroundImage(Res.PathIcon.rmr_icon)
                    }
                }
        )

        Row(
            modifier = Modifier
        )
        {
            SpanText(
                modifier = Modifier
                    .margin(left = Dimen.smallPadding)
                    .fontFamily(FontFamily.Jakarta)
                    .fontSize(FontSizes.extraExtraLargeFontSize)
                    .lineHeight(FontLineHeight.lineNormal)
                    .fontWeight(FontWeight.Bold)
                    .lineHeight(100.percent)
                    .color(Theme.TextPrimary.rgb),
                text = Strings.current().APP_NAME_PART1
            )
            SpanText(
                modifier = Modifier
                    .fontFamily(FontFamily.Jakarta)
                    .fontSize(FontSizes.extraExtraLargeFontSize)
                    .lineHeight(100.percent)
                    .fontWeight(FontWeight.Normal)
                    .color(Theme.TextPrimary.rgb),
                text = Strings.current().APP_NAME_PART2
            )
        }



    }
}